import { SECTION, TAG, REPEATING_CONTENT_BLOCK, REPEATING_TABLE_BLOCK, HTML_CONTENT_BLOCK, CONTENT_BLOCK, DICTATION_CONTENT_BLOCK } from "@/constants/contentControlTypes";

const DICTATION_OUTPUT = "DictationOutput";

class ContentControl {
    constructor(id, type, systemName, displayRuleId) {
        this.id = id;
        this.type = type;
        this.systemName = systemName;
        this.displayRuleId = displayRuleId;
        this.contentControls = [];
    }
}

class Section extends ContentControl {
    constructor(id, systemName, displayRuleId) {
        super(id, SECTION, systemName, displayRuleId);
    }
}

class Tag extends ContentControl {
    constructor(id, name, displayRuleId) {
        super(id, TAG, name, displayRuleId)
    }
}

class RepeatingContentBlock extends ContentControl {
    constructor(id, name, displayRuleId) {
        super(id, REPEATING_CONTENT_BLOCK, name, displayRuleId);
    }
}

class RepeatingTableBlock extends ContentControl {
    constructor(id, name, displayRuleId) {
        super(id, REPEATING_TABLE_BLOCK, name, displayRuleId);
    }
}

class DictationBlock extends ContentControl {
    constructor(id) {
        super(id, DICTATION_CONTENT_BLOCK, DICTATION_OUTPUT, "");
    }
}

class BaseContentBlock extends ContentControl {
    constructor(id, type, systemName, label, version, displayRuleId) {
        super(id, type, systemName, displayRuleId);
        this.label = label;
        this.version = version;
    }
}

class HtmlContentBlock extends BaseContentBlock {
    constructor(id, systemName, label, version) {
        super(id, HTML_CONTENT_BLOCK, systemName, label, version, "");
    }
}

class ContentBlock extends BaseContentBlock {
    constructor(id, systemName, label, version, displayRuleId) {
        super(id, CONTENT_BLOCK, systemName, label, version, displayRuleId);
    }
}

export {
    DICTATION_OUTPUT,
    Section,
    Tag,
    RepeatingContentBlock,
    RepeatingTableBlock,
    HtmlContentBlock,
    ContentBlock,
    DictationBlock
}